import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { of } from 'rxjs';

export const onlyAuthUserGuard: CanActivateChildFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isAuthenticated()) {
        return of(true);
    }

    return of(router.createUrlTree(['/login']));
};
